import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import Denied from "@/pages/Denied";
import { JarvisOrb } from "@/components/JarvisOrb";
import "@/index.css";

function Protected({ children }) {
  const { user, loading, denied } = useAuth();
  if (loading) return <div className="min-h-screen hud-bg flex items-center justify-center"><JarvisOrb state="idle" size={180} /></div>;
  if (denied) return <Denied message={denied.message} />;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function Root() {
  const { user, loading, denied } = useAuth();
  if (loading) return <div className="min-h-screen hud-bg flex items-center justify-center"><JarvisOrb state="idle" size={180} /></div>;
  if (denied) return <Denied message={denied.message} />;
  return user ? <Navigate to="/dashboard" replace /> : <Login />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Root />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" theme="dark" richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </I18nProvider>
  );
}
